export default {
    data() {
        return {
            submitting: false
        }
    },

    methods: {
        /**
         * This allows all the remedial things such as email
         * confirmation, and offer confirmation to be taken care of without
         * code duplication.
         *
         * @param submittedPaymentMethod
         * @param apiUrl
         * @param afterCallback
         * @param onError
         * @returns {null}
         */
        confirmAndSubmitPayment({ submittedPaymentMethod, apiUrl, afterCallback, onError }) {
            this.error = false;

            if (typeof this.checkCustomAmount === 'function' && ! this.checkCustomAmount(submittedPaymentMethod)) return null;

            if (submittedPaymentMethod.type === 'card' && ! this.checkCardType(submittedPaymentMethod)) return null;

            if (submittedPaymentMethod.email !== '' && this.emailConfirmed === null) {
                this.$root.$emit('confirm-email', submittedPaymentMethod.email);
            } else if (! this.offerConfirmed) {
                this.$root.$emit('confirm-offer');
            } else {
                this.submitPayment({ submittedPaymentMethod, apiUrl, afterCallback, onError });
            }
        },

        /**
         * Make actual payment call.
         *
         * @param apiUrl
         * @param submittedPaymentMethod
         * @param afterCallback
         * @param onError
         * @param withLoading
         */
        submitPayment({ submittedPaymentMethod, apiUrl, afterCallback, onError, withLoading = true }) {
            if (this.submitting) return null;

            if (! submittedPaymentMethod.hasOwnProperty('payments')) {
                if (typeof this.checkCustomAmount === 'function' && ! this.checkCustomAmount(submittedPaymentMethod)) return null;

                if (submittedPaymentMethod.type === 'card' && ! this.checkCardType(submittedPaymentMethod)) return null;
            } else {
                submittedPaymentMethod.payments.forEach(payment => {
                    let combinedPaymentWithSubmittedPaymentMethod = {
                        ...payment,
                        ...submittedPaymentMethod
                    };

                    if (typeof this.checkCustomAmount === 'function' && ! this.checkCustomAmount(combinedPaymentWithSubmittedPaymentMethod)) return null;
                });

                if (submittedPaymentMethod.type === 'card' && ! this.checkCardType(submittedPaymentMethod)) return null;
            }

            if (withLoading) {
                this.$root.$emit('loading');
            }

            // this.paymentDate = submittedPaymentMethod.payment_date;

            this.submitting = true;

            this.$http.post(apiUrl, submittedPaymentMethod).then(response => {
                this.submitting = false;

                if (withLoading) {
                    this.$root.$emit('loading');
                }

                afterCallback(response);
            }, error => {
                this.submitting = false;

                if (withLoading) {
                    this.$root.$emit('loading');
                }

                onError(error);
            });
        },

        /**
         * @param {Object} submittedPaymentMethod
         * @returns {Boolean}
         */
        checkCardType(submittedPaymentMethod) {
            let type = this.getCardType(submittedPaymentMethod.cc_number),
                card_exp = submittedPaymentMethod.card_exp.replace(/\s+/g, '').split('/');

            submittedPaymentMethod.cc_type = type;

            if (card_exp.length !== 2) {
                this.error = `Please check your card expiration date is entered correctly. MM/YY`;
            } else {
                submittedPaymentMethod.exp_month = card_exp[0];
                submittedPaymentMethod.exp_year = card_exp[1];

                switch(type) {
                    case 'Discover':
                        this.error = `If you are attempting to make a payment with a Discover or American Express card, please call Customer Service ${this.data.hasOwnProperty('consumerPortalNumber') ? this.data.consumerPortalNumber : ''}.`;
                        break;
                    case 'AMEX':
                        this.error = `If you are attempting to make a payment with a Discover or American Express card, please call Customer Service ${this.data.hasOwnProperty('consumerPortalNumber') ? this.data.consumerPortalNumber : ''}.`;
                        break;
                }
            }

            return ! this.error ? submittedPaymentMethod : false;
        },

        /**
         * @param {Object} submittedPaymentMethod
         * @returns {Boolean}
         */
        checkCustomAmount(submittedPaymentMethod) {
            if (submittedPaymentMethod.type === 'custom') {
                let amount = parseFloat(submittedPaymentMethod.amount);

                if (amount < submittedPaymentMethod.minimum_payment) {
                    alert(`Your entered payment amount must be greater than ${submittedPaymentMethod.minimum_payment | money}`);

                    return false;
                }
            }

            return true;
        },

        /**
         * @returns {void}
         */
        goToEarlyPayOff() {
            this.gtagEvent('early-payoff-from:account');

            setTimeout(() => window.location = `${this.data.consumerPortalBaseUrl}/early-payoff`, 500);
        },

        /**
         * @param number
         * @returns {String}
         */
        getCardType(number)  {
            let cardChecks = [
                { type: 'VISA',         reg: new RegExp("^4") },
                { type: 'Mastercard',   reg: new RegExp("^5[1-5]") },
                { type: 'AMEX',         reg: new RegExp("^3[47]") },
                { type: 'Discover',     reg: new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)") },
                { type: 'Diners',       reg: new RegExp("^36") },
                { type: 'Diners - Carte Blanche', reg: new RegExp("^30[0-5]") },
                { type: 'JCB',          reg: new RegExp("^35(2[89]|[3-8][0-9])") },
                { type: 'VISA',         reg: new RegExp("^(4026|417500|4508|4844|491(3|7))") }
            ];

            let match = cardChecks.find(check => number.match(check.reg) != null);

            return match ? match.type : null;
        },

        /**
         * @param {Object} event
         * @return {void}
         */
        fbEvent(event) {
            setTimeout(function() {
                if (typeof window.fbq !== 'undefined') {
                    window.fbq('track', event);
                }
            }, 500);
        },

        /**
         * @param {Object} event
         * @return {void}
         */
        gtagEvent(event) {
            setTimeout(() => {
                if (typeof window.gtag !== 'undefined') {
                    console.log(event);
                    window.gtag('event', event, {
                        'event_category' : 'consumer-portal',
                    });
                }

                this.$http.post(`${this.$root.$refs['app'].consumerPortalBaseUrl}/api/login-events`, {event: event});
            }, 500);
        },

        /**
         * @param transactionId
         * @param value
         * @param referral
         * @param coupon
         * @param item
         * @return {void}
         */
        gtagPurchaseEvent(transactionId, value, referral, coupon, item) {
            setTimeout(function() {
                if (typeof window.gtag !== 'undefined') {
                    window.gtag('event', 'purchase', {
                        "transaction_id": transactionId,
                        "affiliation": referral,
                        "value": value,
                        "currency": "USD",
                        "coupon": coupon,
                        "items": [
                            item
                        ]
                    });
                }
            }, 500);
        },

        /**
         * @param {Object} i
         * @returns {void}
         */
        gtagDataLayer(i) {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push(i);
            }
        },

        hideChat() {
            if (document.getElementById('mobile-chat-container')) {
                document.getElementById('mobile-chat-container').style.display = 'none';
            }

            if (document.getElementById('fbots-wdgt')) {
                document.getElementById('fbots-wdgt').style.display = 'none';
            }

            console.log('hide chat');
        }
    }
}